<template>
  <div class="main-container">
    <MyEvents />
  </div>
</template>

<script>
import MyEvents from "@/components/templates/MyEvents";

export default {
  components: { MyEvents },
};
</script>